import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class AboutLegalGuardianApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    createLegalGuardian(data) {
        return axios.post(`${URL_API}/cadastro/responsavel-legal/first`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    getLegalGuardian() {
        return axios.get(`${URL_API}/responsavel-legal/`, this.getConfig())
    }

    nextLegalGuardian(data) {
        return axios.put(`${URL_API}/cadastro/responsavel-legal/next`, data, this.getConfig())
    }

    finishLegalGuardian(data) {
        return axios.put(`${URL_API}/cadastro/responsavel-legal/finish`, data, this.getConfig())
    }

    updateLegalGuardian(data) {
        return axios.put(`${URL_API}/responsavel-legal/update`, data, this.getConfig())
    }

    getGender() {
        return axios.get(`${URL_API}/responsavel-legal/genero`, this.getConfig())
    }

    getRace() {
        return axios.get(`${URL_API}/responsavel-legal/raca`, this.getConfig())
    }

    getEducationLevel() {
        return axios.get(`${URL_API}/responsavel-legal/nivel-escolaridade`, this.getConfig())
    }

    getDedicatedTime() {
        return axios.get(`${URL_API}/responsavel-legal/tempo-dedicado`, this.getConfig())
    }

    getWorkingTime() {
        return axios.get(`${URL_API}/responsavel-legal/tempo-trabalho`, this.getConfig())
    }

    getYouAre() {
        return axios.get(`${URL_API}/responsavel-legal/voce-e`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/register-about-legal-guardian/AboutLegalGuardianApi.js